export default __webpack_public_path__ + "static/media/021-space shuttle.8ce2a217.svg";